/**
 * Keep in sync with trustvid-ai-api `SMART_CAMPAIGN_MAX_FILES` default (50).
 * Stitch packs (e.g. scene MP4s + narration + script txt) can exceed 35 files.
 */
export const SMART_CAMPAIGN_MAX_UPLOAD_FILES = 50;
